// extracted by mini-css-extract-plugin
export var button = "_m7-2";
export var card = "_m7-0";
export var closeButtonContainer = "_m7-3";
export var iconContainer = "_m7-1";